/**
 * Console V4 System Pulse and Atlas routes (Spec V4 §14 and §16 H).
 *
 *   GET  /pulse-v3/self-fixes        the pre-approved self-fix runbook (NOT BUILT YET, AF-1589)
 *   POST /pulse-v3/self-fixes/:key   the owner allows or turns off one fix; nothing runs
 *   GET  /atlas/own-model            own-model progress vs the serving model (owner only)
 */
import { route } from './route';
import { AITHORA_PREFIX } from './prefix';

const A = AITHORA_PREFIX;

export type SelfFixKey = 'worker' | 'cron' | 'queue' | 'cache' | 'probe';

export interface SelfFixRow {
  key: SelfFixKey;
  name: string;
  /** When it would run. */
  when: string;
  limit: string;
  /** What happens if it does not work. */
  fail: string;
  allowed: boolean;
}

export interface SelfFixesResponse {
  real: true;
  /** Always false until AF-1589 ships: nothing runs a fix. */
  built: boolean;
  ticket: string;
  /** The owner (by email) toggles; everyone else reads. */
  canEdit: boolean;
  fixes: SelfFixRow[];
  /** Empty until AF-1589: what each fix saw, did, and whether it worked. */
  log: unknown[];
}

/** GET /pulse-v3/self-fixes: Super Admin, Operator, Developer, Partner. */
export const pulseSelfFixes = route<SelfFixesResponse>()('GET', `${A}/pulse-v3/self-fixes`, { honest: true });

/** POST /pulse-v3/self-fixes/:key { allowed }: owner only, sealed to the Truth Ledger. */
export const pulseSelfFixSet = route<SelfFixesResponse, void, { allowed: boolean }>()('POST', `${A}/pulse-v3/self-fixes/:key`, { honest: true });

export interface OwnModelCandidate {
  /** local = our own model (Gemma, own server); mistral = Mistral hosted. */
  key: 'local' | 'mistral';
  /** Shadow answers compared with the serving model. */
  compared: number;
  /** Answers that called the same tools; pct is null under minForPct compared. */
  toolsSame: { n: number; pct: number | null };
  /** Needs the exam judge (AF-1562, AF-881): not built. */
  taskSuccess: null;
  latency: { medianMs: number; maxMs: number } | null;
  errors: { n: number; pct: number | null };
  /** Graduation records are not trusted until AF-1579. */
  jobsGraduated: null;
}

export interface OwnModelResponse {
  real: true;
  shadowProvider: 'off' | 'local' | 'mistral';
  candidates: OwnModelCandidate[];
  /** Null until a full week of shadow answers exists. */
  weeklyTrend: null;
  minForPct: number;
}

/** GET /atlas/own-model: the owner only. */
export const atlasOwnModel = route<OwnModelResponse>()('GET', `${A}/atlas/own-model`, { honest: true });
